export default __webpack_public_path__ + "images/hk-c0a93c089256c99bf337965d0074738d.svg";